import React from "react";
function SitePotential(props) {
  const [value, setValue] = React.useState(null);

  const [structureType, SetstructureType] = React.useState("Per Home");
  const [IsStyle, SetStyle] = React.useState("form-control construction");
  React.useEffect(() => {
    if (props.value == "") {
      setValue(0);
    }
    else {
      setValue(props.value);
    }
    if (props.structureType == "Single Family") { SetstructureType("Per Lot") }
    if (props.structureType == "Apartment" || props.structureType == "Condo") { SetstructureType("Per Unit") }


  }, []);

  if (props.id == 284 || props.id == 285 || props.id == 286) {
    return (
      <>
        <div class="col-md-3 mt-2 col-6" style={{}}>

          <label class="" >{props.name}
          </label>

        </div>
        <div class="col-md-9 mt-2 col-6" style={{}}>

          <input
            type="text"
            key={props.structureType + "-" + props.id}
            id={props.structureType + "-" + props.id}
            value={value}
            readOnly
            class="form-control"
            style={{ maxWidth: "100%" }}
          />

        </div>
      </>
    );
  }
  if (props.id == 256 || props.id == 36 || props.id == 258 || props.id == 69) {
    if (props.id == 258) {
      return (

        <>


          <div class="col-md-4 col-6" >
            <div class="from  d-flex justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  readOnly
                  //placeholder={props.name.split('Per')[0]}

                  class={IsStyle}

                />
              </div>
            </div>
          </div>

        </>
      );
    }
    else {
      if (props.id == 256) {
        if (props.structureType == "Single Family") {
          return (

            <>

              <div class="col-md-6 " >
                <div class="from  d-flex justify-content-between  align-items-center ">
                  <label class=""><u>Total Estimated Value</u>


                  </label>



                </div>
              </div>


            </>
          );
        }
        else {

          return (

            <>


              <div class="col-md-12 input-box1 mt-3">
                <div class="row">
                  <div class="col-md-3"></div>
                  <div class="col-md-2 col"><label class="d-block text-center">Per sqft</label></div>
                  <div class="col-md-3 col"><label class="d-block text-center">{structureType}</label></div>
                  <div class="col-md-3 col"><label class="d-block text-center">Project</label></div>
                </div></div>
              <div class="col-md-3 " >
                <label class="">{props.name.split('Per')[0]}


                </label>



              </div>

              <div class="col-md-3 col-6">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    readOnly
                    //placeholder={props.name.split('Per')[0]}

                    class={IsStyle}

                  />
                </div>
              </div>

            </>
          );
        }


      } else {

        return (

          <>


            <div class="col-md-3 col-6" >
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  readOnly
                  //placeholder={props.name.split('Per')[0]}

                  class={IsStyle}

                />
              </div>
            </div>
          </>
        );
      }
    }
  }
  if (props.id == 37 || props.id == 249 || props.id == 250) {
    if (props.id == 249) {


      return (

        <>
          <div class="ml-2 table-outer mt-4">
            <div class="row mytable ">

              <div class="col-md-12 input-box1 ">
                <div class="row" >
                  <div class="col-md-3"></div>
                  <div class="col-md-3 col"><label class="d-block text-center">Per sqft </label></div>
                  <div class="col-md-3 col"><label class="d-block text-center">{structureType}</label></div>
                  <div class="col-md-3 col"><label class="d-block text-center">Project</label></div>
                </div></div>
              <div class="col-md-3" >
                <label class="">{props.name.split('Per')[0]}

                </label>


              </div>

              <div class="col-md-3 col-6">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    readOnly
                    class={IsStyle}

                  />
                </div>
              </div> </div>
          </div>
        </>
      );

    } else {

      return (

        <>


          <div class="col-md-3 col-6" >
            <div class="test">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                class={IsStyle}
                readOnly
              />
            </div>
          </div>
        </>
      );
    }
  }

  if (props.id == 30 || props.id == 96 || props.id == 215 || props.id == 199 || props.id == 80 || props.id == 71 || props.id == 216 || props.id == 79 || props.id == 188 || props.id == 32 || props.id == 33 || props.id == 35 || props.id == 67 || props.id == 34) {
    if (props.id == 30 || props.id == 199 || props.id == 215 || props.id == 80 || props.id == 216 || props.id == 188 || props.id == 32 || props.id == 33 || props.id == 34 || props.id == 35 || props.id == 67) {
      if (props.id == 216) {



        return (
          <>
            <div class="col-md-3 col-6" style={{}}>
              <label class="">{props.name}
              </label>


            </div>
            <div class="col-md-3 col-6" style={{}}>

              <input

                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                readOnly
                class="form-control"
                style={{ maxWidth: "100%" }}
              />

            </div>
            <div class="col-md-6"></div>
          </>
        );
      }
      if (props.id == 199) {



        return (
          <>
            <div class="col-md-3 col-6 mt-2" style={{}}>
              <label class="">{props.name}
              </label>

            </div>
            <div class="col-md-3 col-6 mt-2" style={{}}>

              <input

                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                readOnly
                class="form-control"
                style={{ maxWidth: "100%" }}
              />
            </div>
          </>
        );
      }
      else {


        return (
          <>
            <div class="col-md-3 mt-2 col-6" style={{}}>
              <label class="">{props.name}
              </label>
            </div>

            <div class="col-md-3 mt-2 col-6" style={{}}>

              <input

                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                readOnly
                //placeholder={props.name}
                style={{ maxWidth: "100%" }}
                class="form-control"

              />
            </div> </>
        );


      }
    }
    else if (props.id == 71) {

      return (
        <>
          <div class="col-md-3 col-6" style={{}}>
            <label class="">{props.name}


            </label>
          </div>
          <div class="col-md-3 col-6" style={{}}>

            <input

              type="text"
              key={props.structureType + "-" + props.id}
              id={props.structureType + "-" + props.id}
              value={value}
              readOnly
              class="form-control"
              style={{ maxWidth: "100%" }}
            />

          </div>
        </>
      );
    }
    else if (props.id == 79) {

      return (
        <>
          <div class="col-md-3 col-6" style={{}}>

            <label class="">{props.name}

            </label>

          </div>
          <div class="col-md-3 col-6" style={{}}>

            <div class="test1" >
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                readOnly
                //placeholder={props.name}
                class="form-control  construction"
                style={{ maxWidth: "100%" }}
              />
            </div>
          </div>
        </>

      );

    }

    else {

      return (
        <>
          <div class="col-md-3 mt-2 col-6" style={{}}>
            <label class="">{props.name}

            </label>

          </div>
          <div class="col-md-3 mt-2 col-6" style={{}}>


            <input
              type="text"
              key={props.structureType + "-" + props.id}
              id={props.structureType + "-" + props.id}
              value={value}
              readOnly
              //placeholder={props.name}
              style={{ maxWidth: "100%" }}
              class="form-control"

            />
          </div>
        </>
      );

    }

  }
  else {
    if (props.id == 185) {


      return (
        <>
          <div class="col-md-2 col-12">
            <label class="d-block">{props.name}
            </label>

            <input

              type="text"
              key={props.structureType + "-" + props.id}
              id={props.structureType + "-" + props.id}
              value={value}
              readOnly
              //placeholder={props.name}

              class="form-control"
              style={{ width: "50%" }}
            />

          </div>

        </>
      );
    }

    else {
      if (props.id == 184) {


        return (
          <div class="col-md-2 col-12">
            <label class="d-block">{props.name}
            </label>

            <input
              type="text"
              key={props.structureType + "-" + props.id}
              id={props.structureType + "-" + props.id}
              value={value}
              readOnly
              class="form-control"

            />
          </div>
        );

      }
      else {

        return (
          <div class="col-md-2 col-12">
            <label class="d-block">{props.name}

            </label>

            <input

              type="text"
              key={props.structureType + "-" + props.id}
              id={props.structureType + "-" + props.id}
              value={value}
              readOnly
              class="form-control"

            />

          </div>
        );

      }
    }
  }


}


export default SitePotential;
